<template>
  <AuthView v-if="!authenticated" @authenticated="enter" @demo="preview" />
  <StudioLayout v-else :user="user" :preview="previewMode" @logout="logout" />
</template>

<script>
import AuthView from '@/components/AuthView.vue'
import StudioLayout from '@/components/StudioLayout.vue'

export default {
  components: { AuthView, StudioLayout },
  data: () => ({
    authenticated: Boolean(localStorage.getItem('ainovel-token')),
    previewMode: localStorage.getItem('ainovel-token') === 'preview',
    user: { username: localStorage.getItem('ainovel-user') || '云海' }
  }),
  methods: {
    enter(user) {
      this.user = user
      this.previewMode = false
      localStorage.setItem('ainovel-user', user.username)
      this.authenticated = true
    },
    preview() {
      localStorage.setItem('ainovel-token', 'preview')
      this.previewMode = true
      this.authenticated = true
    },
    logout() {
      localStorage.removeItem('ainovel-token')
      localStorage.removeItem('ainovel-user')
      this.previewMode = false
      this.authenticated = false

    }
  }
}
</script>
